import { render, staticRenderFns } from "./AllNominees.html?vue&type=template&id=43be16cc&scoped=true&"
import script from "./AllNominees.vue?vue&type=script&lang=js&"
export * from "./AllNominees.vue?vue&type=script&lang=js&"
import style0 from "./AllNominees.scss?vue&type=style&index=0&id=43be16cc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43be16cc",
  null
  
)

export default component.exports